module.exports = __webpack_public_path__ + "img/linkedin.4ad65e3e.png";